import customFetch, { simpleFetch } from './customFetch';

export const getCurrentMegaphoneBanner = () => (
  customFetch('/megaphone-banners?limit=999').then((data) => {
    if (Array.isArray(data)) {
      return data[data.length - 1] || {};
    }

    return [];
  })
);

export const putCurrentMegaphoneBanner = (id, data) => (
  customFetch('/megaphone-banners', {
    method: 'POST',
    body: JSON.stringify({ ...data, id }),
  })
);

export const postMegaphoneBanner = (data) => (
  customFetch('/megaphone-banners', {
    method: 'POST',
    body: JSON.stringify(data),
  })
);

export const invalidateCacheMegaphoneBanner = () => (
  simpleFetch('/megaphone-banners/current/cache', { method: 'DELETE' })
);
